<template>
  <div>
    <div class="content">
      <van-tabs v-model="active" line-height="2px" color="#45B9BC" sticky title-active-color="#45B9BC">
        <van-tab title="视频">
          <van-list v-model="video_loading" :finished="video_finished" finished-text="没有更多内容啦..." @load="onLoad">
            <div class="itemList">
              <ul>
                <li class="fl" v-for="(item,index) in videoList" :key="index">
                  <router-link to="/videoDetails" class="bg_fff radius3">
                    <img :src="item.img" alt="">
                    <div class="itemList_content flex">
                      <p class="itemList_title">{{item.title}}</p>
                      <div class="col_999 message__video_subtitle flex_center"><span class="iconfont icon-liulan"></span><span>2343</span></div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </van-list>
        </van-tab>
        <van-tab title="文章">
          <van-list v-model="article_loading" :finished="article_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="tab__content">
            <router-link to="/articleDetails" class="storeList flex_center articleList" v-for="(articleItem,articleIndex) in articleList" :key="articleIndex">
              <div class="storeList__img"><img :src="articleItem.img_url" alt=""></div>
              <div class="storeList__content">
                <div class="flex storeList__line">{{articleItem.title}}</div>
                <div class="col_999 fs_12 two articleList__subtitle">{{articleItem.subtitle}}</div>
                <div class="col_999 flex_center articleList__browse"><span class="iconfont icon-liulan"></span><span>2343</span></div>
              </div>
            </router-link>
          </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <!--底部固定导航-->
    <tab-bar :message-active="'active'" :message-icon="'/static/img/icon_nav33.png'"></tab-bar>
  </div>
</template>

<script>
  import tabBar from "@/components/tabBar.vue";
  export default {
    name: "message",
    components: { tabBar },
    data() {
      return {
        active: 0,  //顶部标签当前位置
        //视频列表
        videoList: [
          {img:"/static/img/itemList_img1.png",title:"全身理疗技法",num:"2243"},
          {img:"/static/img/itemList_img2.png",title:"足疗按摩技法",num:"2243"},
          {img:"/static/img/itemList_img3.png",title:"瑜伽养生",num:"2243"},
          {img:"/static/img/itemList_img1.png",title:"喝茶养生",num:"2243"},
        ],
        //门店列表
        articleList: [
          {
            img_url: '/static/img/itemList_img1.png',
            title: '日常养生如何吃的放心',
            subtitle: '养脾佳品大红枣',
            browserNum: '5522'
          },{
            img_url: '/static/img/itemList_img2.png',
            title: '日常养生如何吃的放心',
            subtitle: '养脾佳品大红枣养脾佳品大红枣养脾佳品大红枣养脾佳品大红枣养脾佳品大红枣养脾佳品大红枣',
            browserNum: '5522'
          },
        ],
        video_loading: false,
        video_finished: false,
        article_loading: false,
        article_finished: false,
      }
    },
    methods:{
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          var list;
          if (this.active===0){
            list=this.videoList;
          }else if (this.active===1){
            list=this.articleList;
          }
          for (let i = 0; i < 4; i++) {
            list.push(list[0]);
          }
          if (this.active===0){
            // 加载状态结束
            this.video_loading = false;
            // 数据全部加载完成
            if (list.length >= 30) {
              this.video_finished = true;
            }
          }else if (this.active===1){
            // 加载状态结束
            this.article_loading = false;
            // 数据全部加载完成
            if (list.length >= 30) {
              this.article_finished = true;
            }
          }

        }, 500);
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*(服务)项目样式*/
  .message__video_subtitle{
    height: .5rem;
    line-height: .5rem;
    font-size: .5rem;
  }
  .message__video_subtitle .iconfont{
    margin-right: 1px;
  }
  .tab__content{
    padding: .5rem;
  }
  .articleList{
    padding: 0 .75rem 0 0;
    margin-bottom: .5rem;
  }
  .articleList .storeList__img{
    width: 45%;
    flex-shrink: 0;
  }
  .articleList .storeList__content{
    padding: .35rem 0;
  }
  .articleList__subtitle{
    height: 1.6rem;
    margin-bottom: .25rem;
    margin-top: .1rem;
  }
  .articleList__browse{
    justify-content: end;
    -webkit-justify-content: flex-end;
    font-size: .6rem;
    height: .6rem;
    line-height: .6rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/message/message.vue